export default "__VITE_ASSET__DVcQeoWm__"